import Route from '@ember/routing/route';
import protectedRoute from 'lumen/utils/decorators/protected-route';

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['settings.property_tags'],
  redirectTo: 'market.settings',
})
export default class MarketSettingsPropertyTagsRoute extends Route {}
